module.exports = {
  ShanghaiPort: '上海港',
  QingdaoPort: '青島港',
  DeletionGuide: '削除ガイド',
  BusinessData: 'ビジネスデータ',
  DropOffGoods: '降貨',
  CounterDeletion: 'カウンター削除',
  CertificateOfNonBoarding: '乗船証明書',
  CarrierName: 'キャリア名',
  Text1: 'サービス範囲（プラットフォームは',
  Text2: '社の船会社と',
  Text3: '社のキャリアのマニフェスト送信をサポートしています。リストは以下の通りです：',
  Text4: '「事前配分マニフェストの変更または削除」の処理ガイド',
  Title1: 'サービス範囲-プラットフォームのサポート',
  Title2: '船会社のVGMが送った、リストは以下の通り：',
  Remark1: '上海振華（キャリア）',
  Remark2: '東進DJS、安通ONTO、達通EAS、汎舟PCSは禁止',
  Remark3: '上海民生（キャリア）',
  Remark4: '民生船会社の台湾線と日本線は禁止。万海WHLの台湾線は許可',
  Remark5: '錦誠（キャリア）',
  Remark6: '錦江輪船JJは禁止',
  Remark7: '正利（キャリア）',
  Remark8: '「CNC—正利」の台湾線は、キャリアコードとして「CST—宝華」を選択',
  Remark9: '新東（キャリア）',
  Remark10: '「NOS—新東」の韓国仁川線は、キャリアコードとして「NSI—寧波遠洋」を選択',
  Remark11: 'シンガポール海運（キャリア）',
  Remark12: '辺航船会社のサブブランド、SECで始まる提单番号は許可、キャリアは「SCO—シンガポール海運」を選択',
  Remark13: 'シンガポールシーリンク船務（キャリア）',
  Remark14: 'FCSL-UAEボルタは上海でVOLTAの代理、キャリアは「SLS—シンガポールシーリンク船務」を選択',
  Remark15: '上海中聯（キャリア）',
  Remark16: '中聯CUL、日照港RPSは禁止',
  Remark17: '出港前、キャリアが設定したマニフェストの締切時間を過ぎていない場合、かつ全バッチが申告されていない場合：',
  Remark18: 'a) 船会社、キャリア、提单番号、船名、航次、コンテナ番号、シール番号、品名、コンテナタイプを変更する場合：「送信済み」から元のマニフェストを選択し、削除申請を提出し、完了後に新しいマニフェストを再送信します。中聯/OOCL/中外運/振華のコンテナタイプのエラーは削除が必要、他は直接修正可能。',
  Remark19: 'b) 上記9種類以外の情報を変更する場合：「送信済み」からマニフェストを選択し、修正申請を提出し、回復を待ちます。',
  Remark20: 'c) コンソリデート貨物（LCL）の場合：',
  Remark21: 'i) いくつかの貨物情報を修正する必要がある場合、上記b点を参照します。',
  Remark22: 'ii) いくつかの貨物を削除する必要がある場合、同一コンテナ番号のマニフェストを全て削除し、新しいマニフェストを再送信します。',
  Remark23: 'iii) 一つの貨物を追加する場合、直接コンソリデート貨物を送信します（キャリアが航華や鹏华の場合、サブ提单番号はメイン提单と一緒に送信する必要があります）。',
  Remark24: '出港前ですが、キャリアが設定したマニフェストの締切時間を過ぎた場合、または顧客が申告した場合：',
  Remark25: 'a) 顧客が申告した場合、まず申告を取り消します。',
  Remark26: 'b) 削除や修正操作については、対応するキャリアに具体的に相談します（具体的には弊社カスタマーサービスにお問い合わせください）。',
  Remark27: 'c) 放行された場合、紙文書をキャリアのカウンターに提出し、「放行済み」のマークを取り消す必要があります（具体的には弊社カスタマーサービスにお問い合わせください）。',
  Remark28: '出港後、削除申請を行います：',
  Remark29: 'a) 顧客が申告した場合、まず申告を取り消します。',
  Remark30: 'b) 紙文書をキャリアのカウンターに提出し、削除操作を行います：一般的には、少なくとも次の4種類の資料が必要です（参考まで）：「削除申請書」、「申告書」、「削除説明書」、「海関情報ネットワークの転送処理状況のスクリーンショット」（弊社は代理サービスを提供できます、具体的にはカスタマーサービスにお問い合わせください）。',
  Remark31: '付記：各キャリアカウンターのサービス住所',
  CompanyName1: '上海外代',
  CompanyName2: '上海中外運',
  CompanyName3: '上海聯合',
  CompanyName4: '上海華港',
  CompanyName5: '上海順徳',
  CompanyName6: '上海航華',
  CompanyName7: '上海民生',
  CompanyName8: '上海鹏华',
  CompanyName9: '上海鹏海',
  CompanyName10: '上海中聯（中和）',
  CompanyName11: '上海振華',
  CompanyName12: '新海',
  CompanyName13: '錦誠',
  CompanyName14: '東方海外',
  CompanyName15: '上海港聯合',
  CompanyName16: '上海中聯',
  CompanyName17: '鹏华',
  CompanyAddress1: '虹口区吴淞路531号5楼',
  CompanyAddress2: '福建中路188号三楼大厅',
  CompanyAddress3: '虹口区东大名路916号一楼',
  CompanyAddress4: '东大名路501号1601室',
  CompanyAddress5: '海倫路440号2701室',
  CompanyAddress6: '虹口区黄浦路99号2楼',
  CompanyAddress7: '大連路1619号駿豊國際财富広場16楼',
  CompanyAddress8: '楊浦区四平路1063号中天大廈1幢5楼501,502,508室',
  CompanyAddress9: '延安东路700号1807-1809室',
  CompanyAddress10: '虹口区东大名路908号24楼',
  CompanyAddress11: '延安东路700号港泰广场21楼',
  CompanyAddress12: '虹口区天潼路133号上海家化金融大廈8楼',
  CompanyAddress13: '延安东路1200号8楼',
  CompanyAddress14: '延安中路841号20楼'
}
